<template>
    <v-dialog v-model="dialog" width="350" persistent @keydown.esc="cancel" @keydown.enter="cancel">
        <v-card outlined>
            <v-toolbar dense flat>
                <v-toolbar-title class="text-h5">
                    {{ $t('betDialog.orderConfirmTitle') }}
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text class="px-4 py-1 font14">
                <v-container>
                    <v-row style="height: 22px" class="d-flex flex-column justify-center">
                        <BetDialogEvent
                            :cth-name="betFeedData[id].cthName"
                            :cta-name="betFeedData[id].ctaName"
                            :handicap="betFeedData[id].market.handicap"
                            :jw="betFeedData[id].market.js"
                        ></BetDialogEvent>
                        <v-spacer></v-spacer>
                    </v-row>
                    <v-row>
                        <BetDialogInfo :module="module" :id="id" :odds="odds" :stake="stake"></BetDialogInfo>
                    </v-row>
                    <v-row style="height: 32px" class="d-flex align-center pt-2">
                        <span class="pr-2">
                            {{ $t('betDialog.stake') }}:
                            <span class="bold">{{ utils.getCurrencySymbol(user.currency) }}{{ stake }}</span>
                        </span>

                        <span>
                            {{ $t('betDialog.returns') }}:
                            <span class="">{{ utils.getCurrencySymbol(user.currency) }}{{ returns }}</span>
                        </span>
                    </v-row>
                    <v-row style="height: 32px" class="d-flex flex-column align-start justify-center">
                        <span>{{ $t('betDialogConfirm.confirmingText') }}:</span>
                    </v-row>
                    <v-row>
                        <BetDialogConfirmationInfo :module="module" :id="id" :isTopUps="isTopUps" :timeout="timeout"></BetDialogConfirmationInfo>
                    </v-row>
                    <v-row v-if="scoreNotConfirmed" class="orangeText py-2">
                        <p>{{ $t('betDialog.orderConfirmText') }}</p>
                    </v-row>
                    <v-row
                        v-else-if="cornersNotConfirmed"
                        class="orangeText py-2">
                        <p>{{ $t('betDialog.orderCornersConfirmText') }}</p>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions class="pt-0">
                <v-spacer></v-spacer>
                <v-btn tag="a" color="grey" text @click="cancel()">
                    {{ $t('action.cancel') }}
                </v-btn>
                <v-btn :disabled="!isActive" tag="a" color="tbGreen" style="color: white" elevation="0" @click="confirm()">
                    {{ $t('betDialogConfirm.confirm') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import BetDialogEvent from 'Pages/core/betDialog/BetDialogEvent.vue';
    import BetDialogInfo from 'Pages/core/betDialog/BetDialogInfo.vue';
    import BetDialogConfirmationInfo from 'Pages/core/betDialog/BetDialogConfirmationInfo.vue';

    export default {
        name: 'BetDialogConfirm',
        components: {
            BetDialogConfirmationInfo,
            BetDialogInfo,
            BetDialogEvent,
        },
        props: {
            id: {
                default: '0',
                type: String,
            },
            module: undefined,
            odds: {
                default: undefined,
                type: String,
            },
            timeout: {
                default: undefined,
                type: Number,
            },
            stake: {
                default: undefined,
                type: Number,
            },
            returns: {
                default: undefined,
                type: String,
            },
            isTopUps: {
                default: false,
                type: Boolean,
            },
            isActive: {
                default: false,
                type: Boolean,
            },
        },
        data() {
            return {
                dialog: false,
            };
        },
        methods: {
            open() {
                this.dialog = true;
            },
            close() {
                this.dialog = false;
            },
            cancel() {
                this.close();
                // if (typeof this.beforeCancel === 'function') {
                //     this.beforeCancel();
                // }
                // if (_.isEmpty(this.item)) {
                //     this.$emit('cancel', this.close);
                // } else {
                //     this.$emit('cancel', { closeCallback: this.close, item: this.item });
                // }
            },
            confirm() {
                // if (_.isEmpty(this.item)) {
                this.$emit('confirmed', this.close);
                // } else {
                //     this.$emit('deleteItem', { closeCallback: this.close, item: this.item });
                // }
            },
        },
        computed: {
            user() {
                return this.$store.getters['UserModule/getUser'];
            },

            scoreNotConfirmed() {
                let isCorrectSelection = this.betFeedData[this.id].betSelectionId !== this.$const.BET_SELECTION_CORNERS_TEAM_HOME && this.betFeedData[this.id].betSelectionId !== this.$const.BET_SELECTION_CORNERS_TEAM_AWAY &&
                    this.betFeedData[this.id].betSelectionId !== this.$const.BET_SELECTION_CORNERS_TEAM_OVER && this.betFeedData[this.id].betSelectionId !== this.$const.BET_SELECTION_CORNERS_TEAM_UNDER
                ;
                let isLive = this.betFeedData[this.id].marketId == this.$const.DBALL_MARKET_LIVE;

                let time = isLive ? this.betFeedData[this.id].time : null;
                let score = isLive ? this.betFeedData[this.id].sc : null;

                return isCorrectSelection && isLive && (!score || !time);
            },

            cornersNotConfirmed() {
                let isCorrectSelection = this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_CORNERS_TEAM_HOME || this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_CORNERS_TEAM_AWAY ||
                    this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_CORNERS_TEAM_OVER || this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_CORNERS_TEAM_UNDER
                ;
                let isLive = this.betFeedData[this.id].marketId == this.$const.DBALL_MARKET_LIVE;

                let corners = isLive ? this.betFeedData[this.id].corners : null ;

                return isCorrectSelection && isLive && !corners;
            },

            betFeedData: {
                get() {
                    return this.$store.getters[this.module + '/getBetFeedData'];
                },
                set(value) {
                    this.$store.commit(this.module + '/setBetFeedData', value);
                },
            },
        },
    };
</script>
